'use client';

import { useTranslation } from '@/contexts/TranslationContext';
import LanguageSelector from '@/components/LanguageSelector';

interface HeaderProps {
  showNavigation?: boolean;
}

export default function Header({ showNavigation = false }: HeaderProps) {
  const { t } = useTranslation();

  return (
    <nav className="hidden md:block fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm" aria-label="Main navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center space-x-4">
            <h1 className="text-2xl font-bold text-gray-900">Nastenka en Mallorca</h1>
            <LanguageSelector />
          </div>

          {/* Navigation Links - solo si showNavigation es true */}
          {showNavigation && (
            <div className="hidden md:block">
              <div className="ml-10 flex items-center space-x-4">
                <button
                  type="button"
                  onClick={() => document.getElementById('welcome')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
                  aria-label={t('nav.welcome')}
                >
                  {t('nav.welcome')}
                </button>
                <button
                  type="button"
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
                  aria-label={t('nav.about')}
                >
                  {t('nav.about')}
                </button>
                <button
                  type="button"
                  onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
                  aria-label={t('nav.classes')}
                >
                  {t('nav.classes')}
                </button>
                <button
                  type="button"
                  onClick={() => document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
                  aria-label={t('nav.testimonials')}
                >
                  {t('nav.testimonials')}
                </button>
                <button
                  type="button"
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer"
                  aria-label={t('nav.contact')}
                >
                  {t('nav.contact')}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}